if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"status_paldesk","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(6(22|3|58|68)|142|423|475|540|592|714|754|9)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}